import { Poppins, Quicksand } from 'next/font/google'
import React, { useState } from 'react'
import EnrollForm from './enroll-form';
import Link from 'next/link';
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function CourseSchedule({title}) {
    const [formPopup,setFormPopup] = useState(false);
    const handlePopup = () =>{
        setFormPopup(true);
    }
    
    const handleCloseForm = ()=>{
        setFormPopup(false)
     }
  return (
   <>
   <section className={`pdtb50 mpdt30`} style={{backgroundColor:'#FEE9BF'}}>
    <div className='container'>
   <h5 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> Interested in Mastering with <span className={`ylw-clr fwb600 ${popins.className}`}> Learnsoft.org ? </span> </h5>
   <p className={`fs-16 mfs-15 fwb500 tac mt28 tmt24 mmt20 ${quickSand.className}`}>Join an exclusive batch of just 5 students to receive Best-in-class Training, Live Sessions, & Personalized Mentorship from Leading Industry Experts</p>
    <div className='df fac fjc'>
   <Link href={"tel:+917825888899"}> 
   <button onClick={handlePopup} className={` cursor fs-16 mfs-15 cw schedule-btn fwb600 mt50 tmt28 mmt24 ${popins.className}`}>Start Your {title} Career Today!</button>
   </Link>
    </div>
   </div>
   </section>

   </>
)
}
